// Formatting utility functions
import moment from "moment-timezone";

export const formatCurrency = (
  amount: number,
  currency: string = "USD"
): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(amount);
};

export const formatNumber = (num: number): string => {
  return new Intl.NumberFormat("en-US").format(num);
};

export const formatDate = (
  date: Date | string,
  format: string = "MMM DD, YYYY"
): string => {
  return moment(date).format(format);
};

export const formatDateTime = (date: Date | string): string => {
  return moment(date).format("MMM DD, YYYY HH:mm");
};

export const formatRelativeTime = (date: Date | string): string => {
  return moment(date).fromNow();
};

export const truncateText = (text: string, maxLength: number = 50): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};

export const formatWalletAddress = (
  address: string,
  startChars: number = 6,
  endChars: number = 4
): string => {
  if (address.length <= startChars + endChars) return address;
  return `${address.substring(0, startChars)}...${address.substring(
    address.length - endChars
  )}`;
};
